import { render, staticRenderFns } from "./ArchieLoader.vue?vue&type=template&id=4171b4c6"
var script = {}
import style0 from "./ArchieLoader.vue?vue&type=style&index=0&id=4171b4c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports